import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import BasicChartData from 'models/basic-chart-data/basic-chart-data.model';
import BasicChartDataset from 'models/basic-chart-dataset/basic-chart-dataset.model';
import ProjectStat from 'models/project-stat/project-stat.model';
import Project from 'models/project/project.model';
import User from 'models/user/user.model';
import { ProjectService } from 'services/project/project.service';

@Component({
  selector: 'app-stat-project',
  templateUrl: './stat-project.component.html',
  styleUrls: ['./stat-project.component.scss'],
})
export class StatProjectComponent implements OnInit {
  @Input() public instance: Project = new Project();
  public users = new FormControl([]);
  public userList: User[] = [];
  public stat: ProjectStat = new ProjectStat();
  public selectedUser: User = new User();
  public chartData: BasicChartData = new BasicChartData();
  public chartRefreshSubject: BehaviorSubject<BasicChartData> = new BehaviorSubject(this.chartData);
  public globalStat: ProjectStat = new ProjectStat();
  public selectedUsers: User[] = [];
  public globalChartData: BasicChartData = new BasicChartData();
  public globalChartRefreshSubject: BehaviorSubject<BasicChartData> = new BehaviorSubject(this.chartData);
  
  constructor(
    public projectService: ProjectService,
  ) { }

  async ngOnInit() {
    this.userList = await this.projectService.userList(this.instance);
    this.globalStat = await this.projectService.stat(this.instance, new User(), null, null);
    this.selectAll();
    this.refreshGlobalChart();
  }

  selectAll() {
    this.users.setValue(this.userList);
    this.refreshChart();
  }

  deselectAll() {
    this.users.setValue([]);
    this.refreshChart();
  }

  async prepareChartDatasets(): Promise<BasicChartDataset[]> {
    return new Promise(async resolve => {
      let dataSets: BasicChartDataset[] = [];
      for (let i = 0; i < this.users.value.length; i++) {
        let dataSet = new BasicChartDataset();
        let userStat = await this.projectService.stat(this.instance, this.users.value[i], null, null);
        if (i === 0) {
          for (let i = 0; i < userStat.ticketStatusStats.length; i++) {
            this.chartData.labels.push(userStat.ticketStatusStats[i].ticketStatus.niceName);
          }
        }
        for (let j = 0; j < userStat.ticketStatusStats.length; j++) {
          dataSet.data.push(userStat.ticketStatusStats[j].count);
          dataSet.label = userStat.user.firstName + " " + userStat.user.lastName;
          const color = `${Math.floor(Math.random() * 256)},${Math.floor(Math.random() * 256)},${Math.floor(Math.random() * 256)}`;
          dataSet.backgroundColor.push(`rgba(${color},0.5)`);
          dataSet.borderColor.push(`rgb(${color})`);
        }
        dataSets.push(dataSet);
      }
      return resolve(dataSets);
    });
  }

  refreshGlobalChart() {
    let dataSet = new BasicChartDataset();
    for (let i = 0; i < this.globalStat.ticketStatusStats.length; i++) {
      this.globalChartData.labels.push(this.globalStat.ticketStatusStats[i].ticketStatus.niceName);
      dataSet.data.push(this.globalStat.ticketStatusStats[i].count);
    }
    dataSet.label = "Összes ticket, státusz szerint";
    this.globalChartData.datasets = [dataSet];
    this.globalChartRefreshSubject.next(this.globalChartData);
  }

  async refreshChart() {
    this.chartData = new BasicChartData();
    this.chartData.datasets = await this.prepareChartDatasets();
    this.chartRefreshSubject.next(this.chartData);
  }
}
